import React, { useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Button, TextField, Paper } from '@mui/material';
import { ScreenFrame, ConfirmDialog } from '../PrototypeShared';

export default function ProductionOrderFormScreen() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isNew = !id;
  const [product, setProduct] = useState(id ? 'Demo Product A' : '');
  const [saveModal, setSaveModal] = useState(false);
  const [discardModal, setDiscardModal] = useState(false);

  const handleSave = () => {
    setSaveModal(true);
  };

  const handleSaveConfirm = () => {
    setSaveModal(false);
    navigate('/prototype/production-orders');
  };

  const handleDiscard = () => {
    setDiscardModal(true);
  };

  const handleDiscardConfirm = () => {
    setDiscardModal(false);
    navigate('/prototype/production-orders');
  };

  return (
    <ScreenFrame
      title={isNew ? 'New production order' : `Edit order ${id}`}
      actions={
        <>
          <Button component={Link} to="/prototype/production-orders" variant="outlined" size="small">Cancel</Button>
          <Button variant="outlined" color="error" size="small" onClick={handleDiscard}>Discard</Button>
          <Button variant="contained" size="small" onClick={handleSave}>Save</Button>
        </>
      }
    >
      <Paper sx={{ p: 2, maxWidth: 500 }}>
        <TextField fullWidth label="Product" value={product} onChange={(e) => setProduct(e.target.value)} margin="normal" />
        <TextField fullWidth label="Planned date" type="date" margin="normal" defaultValue="2024-03-15" />
        <TextField fullWidth label="Quantity" type="number" margin="normal" defaultValue="100" />
      </Paper>
      <ConfirmDialog open={saveModal} title="Save order" message="Save this production order?" onConfirm={handleSaveConfirm} onCancel={() => setSaveModal(false)} />
      <ConfirmDialog open={discardModal} title="Discard changes" message="Discard unsaved changes?" onConfirm={handleDiscardConfirm} onCancel={() => setDiscardModal(false)} confirmLabel="Discard" />
    </ScreenFrame>
  );
}
